import { IMicrofrontendManifest } from '@cian/mf-registry/shared';

import {
  fetchGetInfrastructureMicrofrontend,
  TGetInfrastructureMicrofrontendRequest,
  TGetInfrastructureMicrofrontendResponse,
} from 'shared/repositories/map-search-frontend/v1/get-infrastructure-microfrontend';
import { IApplicationContext } from 'shared/types/applicationContext';

export async function getInfrastructureMicrofrontendManifest(
  { httpApi, logger, telemetry }: IApplicationContext,
  parameters: TGetInfrastructureMicrofrontendRequest,
): Promise<IMicrofrontendManifest | null> {
  try {
    const res: TGetInfrastructureMicrofrontendResponse = await fetchGetInfrastructureMicrofrontend({
      httpApi,
      parameters,
    });

    return res.response.manifest;
  } catch (e) {
    logger.warning(e, {
      domain: 'getInfrastructureMicrofrontendManifest',
      message: 'Ошибка получения манифеста микрофронта инфраструктуры',
    });

    telemetry.increment('infrastructure-microfrontend-fetch-error');

    return null;
  }
}
